import data from '../../api/profile.json';
import skills from '../../api/skills.json';

const Profile = () => {
  // Filter out the "other" column
  const otherSkill = skills.find((skill) => skill.type === "other");
  const filteredSkills = skills.filter((skill) => skill.type !== "other");

  return (
    <>
      {data && (
        <div key={data.id}>
          <p>{data.description}</p>
        </div>
      )}

      {/* Render the main skills */}
      <div className="row row-cols-1 row-cols-md-4">
        {filteredSkills.map((skill, index) => (
          <div key={index} className="col p-3">
            <div className="glowing-border h-100 p-3">
              <h3 className="fs-4">{skill.type}</h3>
              <ul className="list-unstyled">
                {skill.list.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* Render the "other" column separately */}
      {otherSkill && (
        <div className="p-3 mt-3">
          <h3 className="fs-4 text-accent">{otherSkill.type}</h3>
          <ul className="list-unstyled row row-cols-1 row-cols-sm-2 row-cols-md-4">
            {otherSkill.list.map((item, index) => (
                  <li>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default Profile;
